export default __webpack_public_path__ + "static/media/min- (1).9b5c951b.png";